import { cx } from "@emotion/css";
import { memo, ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createAnonymousLayoutStyles } from "./helpers/createAnonymousLayoutStyles";

export interface AnonymousLayoutProps {
  children: ReactNode;
  containerClassName?: string;
}

export const AnonymousLayout = memo(
  ({ children, containerClassName }: AnonymousLayoutProps) => {
    const classes = createAnonymousLayoutStyles(useTheme());

    return (
      <main className={classes.root}>
        <div className={cx(classes.container, containerClassName)}>
          {children}
        </div>
      </main>
    );
  }
);
